var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2.5 -2.5 24 24",
    width: 24,
    height: 24,
    preserveAspectRatio: "xMinYMin",
    className: "pencil_svg__icon__icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.238 5.472L3.2 14.51l-.591 2.016 1.975-.571 9.068-9.068-1.414-1.415zM13.78 3.93l1.414 1.414 1.318-1.318a.5.5 0 000-.707l-.708-.707a.5.5 0 00-.707 0L13.781 3.93zm3.439-2.732l.707.707a2.5 2.5 0 010 3.535L5.634 17.733l-4.22 1.22a1 1 0 01-1.237-1.241l1.248-4.255 12.26-12.26a2.5 2.5 0 013.535 0z"
  })));
}
export default new URL("/codebuild/output/src2367840440/src/src/assets/icons/pencil.svg", import.meta.url).toString();
export { SvgPencil as ReactComponent };